var translation = {
	Navatar: {
		header: "Профиль AWS",
		subheader: "Профиль помогает улучшить взаимодействие с некоторыми сервисами AWS.",
		profileButtonText: "Посмотреть профиль",
		logOutText: "Выйти из системы",
		logInText: "Авторизоваться",
		createProfileText: "Создать профиль",
		federateLoginModalTitle: "Используйте Midway для доступа к профилю AWS",
		federateLoginModalFirstDescription: "Мы рекомендуем сотрудникам Amazon использовать Midway для доступа к их профилю AWS. Этот рекомендуемый с точки зрения безопасности метод обеспечивает беспрепятственную интеграцию с внутренними системами.",
		federateLoginModalSecondDescription: "Вы видите это сообщение, потому что вошли в систему с адресом электронной почты Amazon и идентификатором AWS Builder. Этот запрос будет отображаться при каждом входе в систему, пока вы не перейдете на Midway или не решите использовать текущий способ входа.",
		federateLoginModalPrimaryButton: "Войти в систему с помощью Midway",
		federateLoginModalSecondaryButton: "Продолжить пользоваться идентификатором AWS Builder"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
